var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-cont show"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"//cnstatic01.e.vhall.com/static/images/menu/detail-bg-new-h5.png","alt":""}})])
}]

export { render, staticRenderFns }